import React from 'react';



const SliderHeaderComponent = ({header,index,description}) => (
  <div className="headerBar clearfix">  
     <h1><span className="sliderIndex">{index}.</span> {header}</h1>
    {description && <p>{description}</p>}
  </div>
)
export default SliderHeaderComponent
